// Shared constants & pure helpers for the Layout Editor.
// Extracted from LayoutEditor.jsx so components can import them without
// re-rendering the massive parent module.

// Preview scale (1pt = 1.5px on screen)
export const SCALE = 1.5;

// Base paper sizes in pt (portrait)
export const PAPER_SIZES = {
  A5: { w: 419.53, h: 595.28 },
  A4: { w: 595.28, h: 841.89 },
  LETTER: { w: 612, h: 792 },
};

// Compute page dimensions from page config
export const pageDims = (pageCfg) => {
  const size = (pageCfg?.size || "A5").toUpperCase();
  const ori = (pageCfg?.orientation || "landscape").toLowerCase();
  const base = PAPER_SIZES[size] || PAPER_SIZES.A5;
  return ori === "landscape" ? { w: base.h, h: base.w } : { w: base.w, h: base.h };
};

export const FONT_FAMILY_OPTIONS = ["helvetica", "times", "courier"];

// Sample values shown in editor for context
export const SAMPLE = {
  company_name: "PT. SARI BAKTI JAYA",
  company_tagline: "CEMENT AND BUILDING MATERIAL DISTRIBUTION",
  company_address: "JL. SETIA BUDI NO. 12 MEDAN, P: 061-8364325 Email: info@saribaktijaya.com",
  distrik: "DISTRIK :  111004 (KARO)",
  tanggal_value: "2026-07-24",
  kepada_value: "PT SEMEN INDONESIA GROUP",
  mohon_text: "Mohon dimuatkan produk semen dengan rincian dibawah ini :",
  no_so_value: "SO-000123",
  no_pol_value: "BK 1234 XX",
  supir_value: "BUDI SANTOSO",
  no_spb_value: "26- 01976   /MD/SBJ/BLW",
  plant_value: "79B4 BELAWAN TERMINAL",
  tipe_value: "FOT",
};

// Field groups for the side panel
export const FIELD_GROUPS = [
  { label: "Company", ids: ["company_logo", "company_name", "company_tagline", "company_address"] },
  { label: "Produk", ids: ["product_label", "product_logo"] },
  { label: "Judul", ids: ["title", "distrik"] },
  { label: "Kolom Kiri", ids: ["tanggal_label", "tanggal_value", "kepada_label", "kepada_value", "mohon_text"] },
  { label: "Baris SO/POL/Supir", ids: ["no_so_label", "no_so_value", "no_pol_label", "no_pol_value", "supir_label", "supir_value"] },
  { label: "Kolom Kanan", ids: ["no_spb_label", "no_spb_value", "plant_label", "plant_value", "tipe_label", "tipe_value"] },
  { label: "Tabel & Keterangan", ids: ["table", "keterangan_title", "keterangan_body", "qr_code", "qr_caption"] },
  { label: "Signature", ids: ["sig_company", "sig_diterima", "sig_dibuat", "signature_dibuat"] },
];

export const IMAGE_FIELDS = new Set([
  "company_logo",
  "product_logo",
  "qr_code",
  "table",
  "sig_diterima",
  "sig_dibuat",
  "signature_dibuat",
]);

export const isShapeId = (id) => id?.startsWith("shape_");

export const GRID_OPTIONS = [
  { value: 0, label: "Off" },
  { value: 2, label: "2 pt" },
  { value: 5, label: "5 pt" },
  { value: 10, label: "10 pt" },
  { value: 20, label: "20 pt" },
];

export const snap = (value, step) => (step > 0 ? Math.round(value / step) * step : value);

// Convert PDF y (from bottom) -> CSS top (from top of page).
// pageH_pt varies per paper size so pass it in.
export const pdfToCssTop = (y_pt, elem_h_pt, pageH_pt) => (pageH_pt - y_pt - elem_h_pt) * SCALE;
export const pdfXtoCss = (x_pt) => x_pt * SCALE;

// Height estimate (in pt) for text elements (used to align top position)
export const textHeightPt = (cfg) => (cfg.size || 8) * 0.85;
